module.exports = __webpack_public_path__ + "img/main.3f470817.webp";